<template>
  <v-container class="my-6">
    <h2 style="color: gray">Cài Đặt Nâng cao</h2>
    <v-divider class="my-3"></v-divider>

    <v-row class="py-3">
      <!-- cấp học -->

      <v-col cols="12">
        <v-checkbox
          hide-details
          value="view-advance-group"
          :label="'Cho phép ' + roleName + ' thiết lập chương trình'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          value="config-academic-level"
          :label="'Cho phép ' + roleName + ' cấu hình Bộ môn'"
          v-model="policies"
          class="ma-0 pa-0"
          hide-details
        ></v-checkbox>
      </v-col>

      <!-- năm học -->
      <!-- <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-school-year"
          :label="'Cho phép ' + roleName + ' xem cài đặt năm học'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col> -->
      <!-- <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          :label="'Cho phép ' + roleName + ' mở năm học'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          :label="'Cho phép ' + roleName + ' tổng kết học kỳ'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          :label="'Cho phép ' + roleName + ' đóng năm học'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col> -->

      <!-- bộ môn -->
      <!-- <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-subjectGroup-list"
          :label="'Cho phép ' + roleName + ' xem danh sách bộ môn'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-new-subjectGroup"
          :label="'Cho phép ' + roleName + ' thêm bộ môn'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-subjectGroup"
          :label="'Cho phép ' + roleName + ' sửa bộ môn'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-subjectGroup"
          :label="'Cho phép ' + roleName + ' xóa bộ môn'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col> -->

      <!-- chương trình đào tạo -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-division-list"
          :label="'Cho phép ' + roleName + ' xem danh sách chương trình đào tạo'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-new-division"
          :label="'Cho phép ' + roleName + ' thêm chương trình đào tạo'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-division"
          :label="'Cho phép ' + roleName + ' sửa chương trình đào tạo'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-division"
          :label="'Cho phép ' + roleName + ' xóa chương trình đào tạo'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- môn học -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-subject-list"
          :label="'Cho phép ' + roleName + ' xem danh sách học phần'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-new-subject"
          :label="'Cho phép ' + roleName + ' thêm học phần'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-subject"
          :label="'Cho phép ' + roleName + ' sửa học phần'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-subject"
          :label="'Cho phép ' + roleName + ' xóa học phần'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-divider class="my-3"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" outlined class="px-4" @click="reset()">Đặt lại</v-btn>
      <v-btn color="primary" elevation="0" class="px-7" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import mixins from './helper/mixins'
export default {
  mixins: [mixins],
}
</script>
